import React from "react";
import { Constant } from "../util/Constant";

// Format numbers in Indian numbering system with two decimals, e.g. 2,23,698.00
const formatRupees = (value) => {
  const n = Number(value) || 0;
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export default function PayoutCard({ title, amount, time, icon, color }) {
  const Icon = icon;
  return (
    <div
      className="bg-white/80 dark:bg-slate-900/80
       backdrop-blur-xl rounded-2xl  
       border border-state-200/50 dark:border-slate-700/50 
       hover:shadow-xl hover:shadow-slate-900/20 
       p-4
       transition-all duration-300 group "
    >
      <div className="w-full flex flex-col">
        <div className="w-full flex items-start justify-between">
          <div className="flex flex-col space-y-1.5">
            <h1 className="text-xs font-semibold text-slate-500 dark:text-slate-400">
              {title}
            </h1>
            <h1 className="text-xl font-bold dark:text-slate-200">
              {Constant.UniCode.rupees + formatRupees(amount)}
            </h1>
            <h1 className="text-xs font-normal text-slate-500 dark:text-slate-400">
              {time}
            </h1>
          </div>
          <Icon
            className={`w-10 h-10 p-2 rounded-xl  ${color.text} ${color.icon_bg} `}
          />
        </div>
      </div>
    </div>
  );
}
